import type { App } from 'vue';
import DotLottiePlayer from '@aarsteinmedia/dotlottie-player-light';

export default function install(app: App) {
  app.component('DotlottiePlayer', DotLottiePlayer);
}
